import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { isNumber, padNumber, toInteger } from "../helpers/date.helper";
import { RegExHelper } from "../helpers/regex.helper";

@Injectable()
export class DateParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (value) {
      const dateRegex = RegExHelper.dateOnly;

      // Check if the input matches the date format
      if (!dateRegex.test(value)) {
        return null;
      }

      const dateParts = value.split('/');
      const month = parseInt(dateParts[0], 10);
      const day = parseInt(dateParts[1], 10);
      const year = parseInt(dateParts[2], 10);

      return { year, month, day };
    }
    return null;
  }

  format(date: NgbDateStruct): string {
      let stringDate = "";
      if (date) {
          stringDate += isNumber(date.month) ? padNumber(date.month) + "/" : "";
          stringDate += isNumber(date.day) ? padNumber(date.day) + "/" : "";
          stringDate += date.year;
      }
      return stringDate;
  }
}
